import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BehaviorSubject, Observable, switchMap } from 'rxjs';

import { BaseChatManager } from '../../core/managers/base-chat.manager';
import { ChatMessageSearchItem, ChatOutgoingMessage, ChatSessionItem } from '../../types/chat-session.types';
import { ChatSessionListComponent } from '../session-list/chat-session-list/chat-session-list.component';
import { ChatInputComponent } from '../session-view/chat-input/chat-input.component';
import { ChatSessionViewComponent } from '../session-view/chat-session-view/chat-session-view.component';
import { ChatSearchSessionsComponent } from '../search/chat-search-sessions/chat-search-sessions.component';
import { ChatSearchMessagesComponent } from '../search/chat-search-messages/chat-search-messages.component';
import { TDropdownListItem, UiInputComponent, UiFeedbackStateComponent, UiScrollBarComponent } from '@cynteka/ui-kit';


type ChatManagerViewConfig = {
    showSearch: boolean;
    showInputWithoutSession: boolean;
    emptySessionListInfo?: Partial<Pick<UiFeedbackStateComponent, 'title' | 'text' | 'button' | 'secondButton' | 'illustrationName' | 'caption' >>
    chatSession: Partial<Pick<ChatSessionListComponent, 'type' | 'showAvatar' | 'createLabel'>> & { menuItems?: (session: ChatSessionItem) => TDropdownListItem[] };
    chatInput: Pick<ChatInputComponent, 'allowFiles' | 'allowVoice'>;
};

@Component({
    selector: 'chat-manager-view',
    standalone: true,
    imports: [CommonModule, ChatSessionListComponent, ChatSessionViewComponent, ChatInputComponent, ChatSearchSessionsComponent, ChatSearchMessagesComponent, UiInputComponent, UiFeedbackStateComponent, UiScrollBarComponent],
    templateUrl: './chat-manager-view.component.html',
    styleUrls: ['./chat-manager-view.component.scss'],
})
export class ChatManagerViewComponent implements OnInit {

    @Input() public manager!: BaseChatManager;

    /** Сохранённая позиция скролла списка сообщений. */
    @Input() public restoreScrollTop: number | null = null;

    @Output() public scrollPositionChange = new EventEmitter<number>();

    @ViewChild(ChatInputComponent) private initialFileInput?: ChatInputComponent;
    @ViewChild(ChatSessionViewComponent) private sessionView?: ChatSessionViewComponent;

    public get fileInput(): ChatInputComponent | undefined {
        return this.sessionView?.fileInput ?? this.initialFileInput;
    }

    public viewConfig!: ChatManagerViewConfig;

    public readonly searchQuery$ = new BehaviorSubject<string>('');
    public searchSessions$!: Observable<ChatSessionItem[]>;
    public searchMessages$!: Observable<ChatMessageSearchItem[]>;

    public ngOnInit(): void {
        const viewConfigFromManager: Partial<ChatManagerViewConfig> = this.manager?.template?.config?.chatManagerViewConfig ?? {};

        this.viewConfig = {
            showSearch: viewConfigFromManager?.showSearch ?? false,
            showInputWithoutSession: viewConfigFromManager?.showInputWithoutSession ?? false,
            emptySessionListInfo: viewConfigFromManager?.emptySessionListInfo,
            chatSession: viewConfigFromManager?.chatSession ?? {
                showAvatar: false,
                createLabel: null,
            },
            chatInput: viewConfigFromManager?.chatInput ?? {
                allowFiles: false,
                allowVoice: false,
            },
        };

        this.searchSessions$ = this.searchQuery$.pipe(
            switchMap(query => query ? this.manager.searchSessions(query) : []),
        );
        this.searchMessages$ = this.searchQuery$.pipe(
            switchMap(query => query ? this.manager.searchMessages(query) : []),
        );
    }

    public onSearchInput(event: Event): void {
        this.searchQuery$.next((event.target as HTMLInputElement).value);
    }

    public clearSearch(): void {
        this.searchQuery$.next('');
    }

    /** Показывать ли аватар в строках списка. */
    // public get showSessionAvatar(): boolean {
    //     return false;
    //     // return this.manager?.template?.config?.showSessionAvatar !== false;
    // }

    // /** Метка кнопки создания сессии (если есть в emptyState). */
    // public get createSessionLabel(): string | null {
    //     if (this.showInputWithoutSession) {
    //         return null;
    //     }

    //     return null;

    //     // const es = this.manager?.template?.config?.emptyState;
    //     // if (!es) return null;
    //     // return es.action?.label ?? null;
    // }

    // /** Показывать ли действие удаления для сессий списка. */
    // public get showDeleteSessionAction(): boolean {
    //     return false;
    //     // return this.manager?.template?.config?.showDeleteSessionAction === true;
    // }

    // /** Показывать ли поле ввода до создания активной сессии. */
    // public get showInputWithoutSession(): boolean {
    //     return this.manager?.template?.config?.chatManagerViewConfig?.showInputWithoutSession === true;
    //     // return this.manager?.template?.config?.showInputWithoutSession === true;
    // }

    public createSession(): void {
        // const es = this.manager?.template?.config?.emptyState;
        // if (!es || !es.action) return;
        // es.action.cb();
    }

    /** Создаёт новую сессию и отправляет в неё первое сообщение. */
    public startSessionWithMessage(message: ChatOutgoingMessage): void {
        this.manager.createSession(message);
    }

    /** Удаляет сессию через текущий менеджер. */
    public deleteSession(sessionId: string): void {
        this.manager.deleteSession(sessionId);
    }

}
